import React from 'react';
import {
    Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription
} from 'shared/components/ui/dialog';
import {
    cn
} from 'shared/lib/utils';
import {
    stepKindLabel, STEP_KIND_DESCRIPTIONS
} from './copy';
import {
    STEP_KINDS
} from './stepKindCatalog';

/**
 * Card-grid dialog for picking a procedure step kind.
 */
export default function OpcodeStepKindPicker({
    open,
    onOpenChange,
    onSelect,
    title = 'Add a step',
    description
}) {
    const desc = description ?? `${STEP_KINDS.length} step kinds — pick what this step should do. You can rename it after adding.`;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-3xl gap-0 overflow-hidden p-0 sm:max-w-3xl">
                <DialogHeader className="border-b bg-muted/30 px-6 py-5">
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{desc}</DialogDescription>
                </DialogHeader>

                <div className="grid max-h-[min(70vh,520px)] grid-cols-1 gap-3 overflow-y-auto p-6 sm:grid-cols-2">
                    {STEP_KINDS.map((k) => {
                        const technical = stepKindLabel(k.kind, 'advanced');
                        const friendly = stepKindLabel(k.kind, 'simple');
                        const description = STEP_KIND_DESCRIPTIONS[k.kind] || '';

                        return (
                            <button
                                key={k.kind}
                                type="button"
                                onClick={() => onSelect(k.kind)}
                                className={cn(
                                    'group rounded-xl border bg-card p-4 text-left transition-all',
                                    'hover:border-primary hover:shadow-md hover:ring-2 hover:ring-primary/10',
                                    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary'
                                )}
                            >
                                <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                                    <span
                                        className={cn(
                                            'inline-block rounded-md px-2.5 py-1 font-mono text-sm font-bold uppercase tracking-wide',
                                            k.bgColor,
                                            k.color
                                        )}
                                    >
                                        {technical}
                                    </span>
                                    <span className="text-sm font-semibold leading-tight">
                                        {friendly}
                                    </span>
                                </div>
                                <p className="mt-1.5 text-xs leading-relaxed text-muted-foreground">
                                    {description}
                                </p>
                            </button>
                        );
                    })}
                </div>
            </DialogContent>
        </Dialog>
    );
}
